import Credentials from '@/modules/auth/domain/credentials'
import { Route } from 'vue-router'
import * as firebase from 'firebase/app'
import 'firebase/auth'

const REDIRECT_TO_PARAM = 'redirectTo'

class AuthService {
  async login (credentials: Credentials) {
    try {
      await firebase.auth().signInWithEmailAndPassword(credentials.username!, credentials.password!)
      return true
    } catch (e) {
      return false
    }
  }

  loginPath (route: Route) {
    let path = '/login'
    if (route.query[REDIRECT_TO_PARAM]) {
      path += `?${REDIRECT_TO_PARAM}=${route.query[REDIRECT_TO_PARAM]}`
    } else if (route.name !== 'login') {
      path += `?${REDIRECT_TO_PARAM}=${encodeURI(route.fullPath)}`
    }
    return path
  }

  mainPath (currentRoute: Route) {
    const query = {}
    const redirectToVal = currentRoute.query[REDIRECT_TO_PARAM]
    const path = redirectToVal ? redirectToVal as string : '/'
    return { path, query }
  }
}

export default new AuthService()
